module.exports = __webpack_public_path__ + "media/img/trophy-icon-56d0a824b3dc30899dfbf1c2f4ecdefa.png";